import { emptyArr } from 'util/arrays'

export const selectGroups = state => state.groups || emptyArr
